  var baseWidth = 1440;
  var pageCaseIndex = 0;
  var tefloCaseStudyAnimateArr = [];
  function updateBaseWidth() {
    const width = window.innerWidth;
    baseWidth = width;
    if (width > 2050) {
      document.documentElement.style.setProperty('--base-width', 2050);  // For 2K+ displays
    } else if (width > 1700) {
    
      document.documentElement.style.setProperty('--base-width', 1700);
    } else if (width > 1500) {

      document.documentElement.style.setProperty('--base-width', 1600);
    } else if (width > 1400) {

      document.documentElement.style.setProperty('--base-width', 1440);
    } else if (width > 1200) {
    
      document.documentElement.style.setProperty('--base-width', 1350);
    }
    else if (width > 1024) {

      document.documentElement.style.setProperty('--base-width', 1250);
    } else if (width > 768) {

      document.documentElement.style.setProperty('--base-width', 1050);

    } else if (width > 680) {

      document.documentElement.style.setProperty('--base-width', 950);

    }
    else {

      document.documentElement.style.setProperty('--base-width', 750);

    }


    if (baseWidth > 2050) {
    document.documentElement.style.setProperty('--base-font', settings.teflo_font_2560_size);
  } else if (baseWidth > 1900) {
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1920_size);
    }else if(baseWidth > 1800 && baseWidth <= 1900){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1820_size);
    }else if(baseWidth > 1700 && baseWidth <= 1800){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1720_size);
    }else if(baseWidth > 1600 && baseWidth <= 1700){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1620_size);
    }else if(baseWidth > 1500 && baseWidth <= 1600){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1520_size);
    }else if(baseWidth > 1400 && baseWidth <= 1500){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1440_size);
    }else if(baseWidth > 1300 && baseWidth <= 1400){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1320_size);
    }else if(baseWidth > 1150 && baseWidth <= 1300){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1220_size);
    }else if(baseWidth > 1024 && baseWidth <= 1150){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_1024_size);
    }else if(baseWidth > 900 && baseWidth <= 1024){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_900_size);
    }else if(baseWidth > 769 && baseWidth <= 900){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_769_size);
    }else if(baseWidth > 668 && baseWidth <= 769){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_768_size);
    }else if(baseWidth > 480 && baseWidth <= 668){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_468_size);
    }else if(baseWidth <= 480){
      document.documentElement.style.setProperty('--base-font', settings.teflo_font_375_size);
    }



    if(pageCaseIndex>0){

      tefloCaseStudyAnimate();
    }
  
    
  }
  updateBaseWidth();
  window.addEventListener('resize', updateBaseWidth);



  function tefloCaseStudyAnimate() {
      if(window.innerWidth > 1024){
        gsap.registerPlugin(ScrollTrigger);
        if(tefloCaseStudyAnimateArr.length == 0){
          try {
              const items = document.querySelectorAll(".teflo-case-studie-list-item-animate");
              items.forEach((item,index) => {
              const lt = item.querySelector(".teflo-case-studie-list-item-img");

              var  tefloCaseStudyAnimateEle =  ScrollTrigger.create({
                      trigger: item,
                      start: "top top",
                      end: () => "+=" + item.offsetHeight,
                      pin: lt,
                      pinSpacing: false,
                      onEnter: () => items.style.zIndex = items.length + index,
                      onLeaveBack: () => items.style.zIndex = index,
                  });
                  tefloCaseStudyAnimateArr.push(tefloCaseStudyAnimateEle);
              });

            
          
          } catch (error) {
            
          }
        }
    }else{
      if(tefloCaseStudyAnimateArr.length>0){
        destroyAnimations(tefloCaseStudyAnimateArr);
      }
    }
  }

  function destroyAnimations(animations) {
    animations.forEach((animation, index) => {
      if (animation) {
        animation.kill(); 
      
        gsap.set(animation.target, { clearProps: "all" }); 
        // animation.target.forEach((el) => {
        //   
        // });
      }
    });
    animations.length = 0;
  }





  // disable scroll
  function disableScroll() {
    if (window.innerWidth <= 1024) {
      document.body.style.overflow = 'hidden';
    }
  }

  //scroll 
  function enableScroll() {
    if (window.innerWidth <= 1024) {
      document.body.style.overflow = '';
    }
  }